<div class="wrapper">
  <input
    type="checkbox"
    [checked]="checkedValue"
    [disabled]="disabled"
    (change)="change($event)"
    [id]="id"
    [ngClass]="isFixed ? 'disabled' : null"
  />
  <label [for]="id"></label>
</div>
